import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import Modal from 'shared/components/Modal';
import s from './ModalContainer.css';

const isClient = process.env.BROWSER;

class ModalContainer extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func,
    isOpen: PropTypes.bool,
    modalCN: PropTypes.string,
  };
  static defaultProps = {
    isOpen: false,
    modalCN: '',
    onClose: undefined,
  };

  render() {
    const { children, onClose, isOpen, modalCN } = this.props;
    if (!isClient) return null;
    return (
      isOpen && (
        <Modal>
          <div className={s.root}>
            <div className={s.background} onClick={onClose} />
            <div className={cx(s.content, modalCN || s.contentParams)}>{children}</div>
          </div>
        </Modal>
      )
    );
  }
}

export default withStyles(s)(ModalContainer);



// WEBPACK FOOTER //
// ./src/shared/components/ModalContainer/ModalContainer.js